import React, { useContext, useState } from 'react';
import CreatePostModal from '../modal/CreatePostModal';
import '../../Forum.css';
import './Sidebar.css';
import PopularTagsStack from '../popularTags/PopularTags';
import { Fade } from 'react-bootstrap';
import { ContentContext } from '../content/ContentContext';
import { useFilter } from "../filterContext/FilterContext";
import Toggle from 'react-toggle';
import { Check, Heart } from 'react-feather';
import { useUser } from '../loggedUserContext/LoggedUserContext';

const Sidebar = ({ setSearchQuery }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { content } = useContext(ContentContext);
  const { filter, setFilter, onlyOfficial, setOnlyOfficial } = useFilter();
  const { userId } = useUser();

  const openModal = () => {
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false);
  }

  // Handle search query change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Handle sort filter change
  const handleSortChange = (event) => {
    const selectedValue = event.target.value;
    setFilter(selectedValue);
  }

  const handleToggleChange = (event) => {
    const selectedValue = event.target.checked;
    setOnlyOfficial(selectedValue);
  }

  return (
    <Fade in={content === "PostList"} timeout={300} unmountOnExit>
      <div className="inner-sidebar">
        {userId != "ANONYMOUS" ? <div className="inner-sidebar-header justify-content-center">
          <button className="btn btn-primary has-icon btn-block" type="button" onClick={openModal}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus mr-2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Discutie noua
          </button>
        </div> : ""}
        <div style={{ borderBottom: "1px solid #cbd5e0" }} className='d-flex flex-column justify-content-center'>
          <select className="custom-select custom-select-sm w-auto mt-3 mx-3" value={filter} onChange={handleSortChange}>
            <option value="latest">Cele mai recente</option>
            <option value="popular">Cele mai populare</option>
            <option value="most_likes">Cele mai apreciate</option>
            <option value="most_views">Cele mai vizionate</option>
            <option value="most_comments">Cele mai multe comentarii</option>
          </select>
          <span className="input-icon input-icon-sm w-auto mt-3 mx-3">
            <input
              type="text"
              className="form-control form-control-sm bg-gray-200 border-gray-200 shadow-none mb-4"
              placeholder="Cauta in Discutii"
              onChange={handleSearchChange}
            />
          </span>
          <label class="align-self-center align-items-center d-flex mb-2">
            <span>Postari eDevize</span>
            <Toggle
              checked={onlyOfficial}
              className='onlyOfficial'
              onChange={handleToggleChange} />
          </label>
        </div>
        <div className="inner-sidebar-body p-0 mt-3">
          <div className="p-3 h-100" data-simplebar="init">
            <div className="simplebar-wrapper">
              <div className="simplebar-height-auto-observer-wrapper">
                <div className="simplebar-height-auto-observer"></div>
              </div>
              <div className="simplebar-mask">
                <div className="simplebar-offset">
                  <div className="simplebar-content-wrapper">
                    <div className="simplebar-content">
                      <PopularTagsStack />
                    </div>
                  </div>
                </div>
              </div>
              <div className="simplebar-placeholder"></div>
            </div>
            <div className="simplebar-track simplebar-horizontal">
              <div className="simplebar-scrollbar"></div>
            </div>
            <div className="simplebar-track simplebar-vertical">
              <div className="simplebar-scrollbar"></div>
            </div>
          </div>
        </div>
        <CreatePostModal isOpen={modalIsOpen} onRequestClose={closeModal} />
      </div>
    </Fade>
  )
}

export default Sidebar;
